import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Input from '~/ui/components/inputs/Input';
import DatePicker from '~/ui/components/inputs/DatePicker';

interface IProps {
  index: number;
  isDeletable: boolean;
  onRemove?: (index: number) => void;
}

const CarePlanMedication = ({ index, isDeletable, onRemove }: IProps): ReactElement => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={3} alignItems="center">
      <Grid item xs>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <Input
              name={`carePlanMedications.${index}.name`}
              label="Name"
              required
              register={register}
              errors={errors}
            />
          </Grid>
          <Grid item xs={2}>
            <DatePicker
              name={`carePlanMedications.${index}.startDate`}
              label="Start Date"
              control={control}
              errors={errors}
              isDateOnly
              isInBody
            />
          </Grid>
          <Grid item xs={2}>
            <DatePicker
              name={`carePlanMedications.${index}.endDate`}
              label="End Date"
              control={control}
              errors={errors}
              isDateOnly
              isInBody
            />
          </Grid>
          <Grid item xs={5}>
            <Input
              name={`carePlanMedications.${index}.reason`}
              label="Reason"
              register={register}
              errors={errors}
            />
          </Grid>
        </Grid>
      </Grid>
      {isDeletable && (
        <Grid item>
          <IconButton title="Remove" onClick={() => onRemove(index)}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default CarePlanMedication;
